const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M18.5 8c.83 0 1.5-.67 1.5-1.5S19.33 5 18.5 5H6.39l3 3h1.83l-.55 1.28l2.09 2.09L14.21 8h4.29zm-1.06 10.88L4.12 5.56a.996.996 0 1 0-1.41 1.41l6.26 6.26l-1.65 3.84c-.39.92.28 1.93 1.27 1.93c.55 0 1.05-.33 1.27-.84l1.21-2.83l4.95 4.95c.39.39 1.02.39 1.41 0c.4-.38.4-1.01.01-1.4z\"/>"
};
exports.__esModule = true;
exports.default = data;
